export default "__VITE_ASSET__07c4d1ab__"